<script>
import { getFixedStyle, getColumnWidth } from './utils'
export default {
  name: 'RkTableTbody',
  props: ['store', 'hasEdgePadding'],
  computed: {
    data() {
      return this.store.data
    },
    columns() {
      return this.store.columns
    },
    currentRow() {
      return this.store.currentRow
    }
  },
  methods: {
    rowClick(row, index) {
      this.$emit('row-click', row, index)
    },
    rowDblclick(row) {
      this.$emit('row-dblclick', row)
    }
  },
  render(createElement) {
    return createElement(
      'div',
      {
        class: {
          'rk-table__body': true
        }
      },
      this.data.map((row, rindex) => {
        return createElement(
          'div',
          {
            class: {
              'rk-table__row': true,
              'rk-table__row--body': true,
              'rk-table__row--highlight': rindex === this.currentRow
            },
            on: {
              click: () => {
                this.rowClick(row, rindex)
              },
              dblclick: () => {
                this.rowDblclick(row)
              }
            }
          },
          this.columns.map((column, cindex) => {
            return createElement(
              'div',
              {
                style: {
                  'z-index': column.fixed ? 1 : 0,
                  ...getColumnWidth(column.width),
                  ...getFixedStyle(this.columns, column.fixed, cindex)
                },
                class: {
                  'edge-left-padding': cindex === 0 && this.hasEdgePadding,
                  'edge-right-padding': cindex === this.columns?.length - 1 && this.hasEdgePadding,
                  'rk-table__column': true,
                  [`rk-table__column--${column.align}`]: true
                }
              },
              [column.renderCell.call(null, createElement, { row, index: rindex })]
            )
          })
        )
      })
    )
  }
}
</script>
